import React from 'react';
import {Input} from 'antd';

import {FormFieldInputWrapperClasses, FormFieldWrapperClasses} from '../';
import {trb, generateId} from '../../../Utilities';

export class InputFormField extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            active: !this.props.input.value && this.props.input.value !== 0
            && !this.props.defaultValue && this.props.defaultValue !== 0 ? true : false,
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if ((this.props.input.value && this.props.input.value !== prevProps.input.value)
        || (this.props.defaultValue  && this.props.defaultValue !== prevProps.defaultValue)) this.setState({
            active: false,
        });
    }

    onBlur = (e) => {
        if (!this.props.input.value && this.props.input.value !== 0) this.setState({
            active: true
        });
        this.props.input.onBlur(e);
        if (this.props.onBlur) this.props.onBlur(e.target.value);
    }

    onSelect = () => {
        this.setState({
            active: false
        });
    }

    render = () => {
        const {
            title,
            titleWithoutTranslate,
            className,
            classNameField,
            classNameTitle,
            classNameError,
            size,
            inline,
            placeholder,
            disabled,
            meta,
            inputType,
            autoFocus,
            addonBefore,
            suffix,
            maxLength,
            defaultValue
        } = this.props,
        {active} = this.state;

        return <div className={FormFieldWrapperClasses(className, inline, disabled, active)}>
            {title && <div className={
                classNameTitle
                ? 'form-field-title ' + classNameTitle
                : inline
                    ? (className && className.indexOf('col-12') === -1) || (className && className.indexOf('col-12') !== -1 && className.indexOf('col-md-') !== -1)
                        ? 'form-field-title col-12 col-md-5 text-left text-md-right pb-2 pb-md-0 pr-md-0'
                        : 'form-field-title col-12 col-md-3 text-left text-md-right pb-2 pb-md-0'
                    : 'form-field-title col-12'
            }>{titleWithoutTranslate ? title : trb(title)}</div>}
            <div className={
                classNameField
                    ? 'form-field-item ' + classNameField
                    : FormFieldInputWrapperClasses(meta.error, meta.submitError, meta.touched, inline, className)}>
                <Input
                    {...this.props.input}
                    name={`${this.props.input.name} ${generateId()}`}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="none"
                    spellCheck="off"
                    size={size}
                    placeholder={trb(placeholder)}
                    disabled={disabled}
                    value={this.props.input.value}
                    onChange={this.props.input.onChange}
                    type={inputType}
                    autoFocus={autoFocus}
                    addonBefore={addonBefore}
                    suffix={suffix}
                    maxLength={maxLength}
                    defaultValue={defaultValue}
                    onBlur={this.onBlur}
                    onSelect={this.onSelect}
                />
            </div>
            <div className={classNameError
                ? 'form-field-error ' + classNameError
                : inline ? 'form-field-error col-12 text-right' : 'form-field-error col-12 text-right'
            }>
                {meta.touched && (meta.error || meta.submitError)}
            </div>
        </div>
    }
};
